import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
//eslint-disable-next-line
import { css } from "styled-components/macro";
import { SectionHeading } from "components/misc/Headings.js";

import { ReactComponent as SvgDecoratorBlob3 } from "../../images/svg-decorator-blob-3.svg";

import SupportIconImage from "../../images/support-icon.svg";
import ShieldIconImage from "../../images/shield-icon.svg";
import CustomizeIconImage from "../../images/customize-icon.svg";
import FastIconImage from "../../images/fast-icon.svg";
import ReliableIconImage from "../../images/reliable-icon.svg";
import SimpleIconImage from "../../images/simple-icon.svg";

const Container = tw.div`relative`;

const ThreeColumnContainer = styled.div`
  ${tw`flex flex-col items-center md:items-stretch md:flex-row flex-wrap md:justify-center max-w-screen-xl mx-auto py-20 md:py-24`}
`;
const Heading = tw(SectionHeading)`w-full`;

const Column = styled.div`
  ${tw`md:w-1/2 lg:w-1/3 px-6 flex`}
`;

const Card = styled.div`
  ${tw`flex flex-col mx-auto max-w-xs items-center px-6 py-10 border-2 border-dashed border-primary-500 rounded-lg mt-12`}
  .imageContainer {
    ${tw`border-2 border-primary-500 text-center rounded-full p-6 flex-shrink-0 relative`}
    img {
      ${tw`w-8 h-8`}
    }
  }

  .textContainer {
    ${tw`mt-6 text-center`}
  }

  .title {
    ${tw`mt-2 font-bold text-xl leading-none text-primary-500`}
  }

  .description {
    ${tw`mt-3 font-semibold text-secondary-100 text-sm leading-loose`}
  }
`;

const DecoratorBlob = styled(SvgDecoratorBlob3)`
  ${tw`pointer-events-none absolute right-0 bottom-0 w-64 opacity-25 transform translate-x-32 translate-y-48 `}
`;
const Svg = styled.div`
  ${tw`bg-primary-500 `}
  width:30px;
  height:30px;
  -webkit-mask: url(${props => props.image}) no-repeat center;
  mask: url(${props => props.image}) no-repeat center;
  mask-size: cover;`;

export default () => {
  /*
   * This componets has an array of object denoting the cards defined below. Each object in the cards array can have the key (Change it according to your need, you can also add more objects to have more cards in this feature component):
   *  1) imageSrc - the image shown at the top of the card
   *  2) title - the title of the card
   *  3) description - the description of the card
   *  If a key for a particular card is not provided, a default value is used
   */

  const cards = [
    {
      imageSrc: ShieldIconImage,
      title: "Supervisão de Manutenção",
      description: "Garantimos uma gestão eficiente da manutenção do condomínio, realizando inspeções regulares, coordenando reparos e implementando serviços de manutenção preventiva para preservar a qualidade do edifício."
    },
    { 
      imageSrc: SupportIconImage, 
      title: "Apoio Jurídico" ,
      description: "Oferecemos suporte jurídico completo aos condóminos e ao condomínio, auxiliando na resolução de questões legais e administrativas, garantindo conformidade com a legislação vigente e protegendo os direitos de todos os envolvidos."
    },
    { 
      imageSrc: SimpleIconImage, 
      title: "Relacionamento Próximo com os Condóminos",
      description: "Mantemos uma comunicação aberta e uma abordagem acessível com todos os condóminos, promovendo um ambiente de colaboração e entendimento mútuo para resolver questões de forma eficaz."
    },
    { 
      imageSrc: ReliableIconImage, 
      title: "Elaboração de Regulamentos",
      description: "Auxiliamos na elaboração ou modificação dos regulamentos do condomínio, fornecendo orientação especializada para criar diretrizes claras e justas que promovam a harmonia e o bom convívio entre os condóminos."
    },
    { 
      imageSrc: FastIconImage, 
      title: "Resolução Rápida de Problemas",
      description: "Comprometemo-nos a agir prontamente na resolução de problemas emergentes no condomínio, garantindo uma resposta rápida e eficiente para lidar com qualquer questão que possa surgir."
    },
    { 
      imageSrc: CustomizeIconImage, 
      title: "Gestão de Assembleias",
      description: "Preparamos, convocamos e coordenamos assembleias ordinárias e extraordinárias de condóminos, garantindo que todos os procedimentos sejam conduzidos de acordo com as normas legais e estatutárias."
    }
  ];
  return (
    <Container id='servicos'>
      <ThreeColumnContainer>
        <Heading><span tw="text-primary-500">Serviços</span></Heading>
        {cards.map((card, i) => (
          <Column key={i}>
            <Card>
              <span className="imageContainer">
                <Svg image={card.imageSrc} />
              </span>
              <span className="textContainer">
                <span className="title">{card.title || "Fully Secure"}</span>
                <p className="description">
                  {card.description }
                </p>
              </span>
            </Card>
          </Column>
        ))}
      </ThreeColumnContainer>
      <DecoratorBlob />
    </Container>
  );
};
